import React from 'react';
import { ChevronRight, ExternalLink } from 'lucide-react';

import { cn } from '@/lib/utils';

const FileChangeGroupCard = ({
  icon: Icon,
  title,
  linkHref = '',
  linkLabel = 'Open',
  linkIcon: LinkIcon = ExternalLink,
  deletionCount = 0,
  metaItems = [],
  countValue,
  countLabel,
  isExpanded = false,
  onToggle,
  children,
}) => (
  <section className="overflow-hidden rounded-xl border border-border/35 bg-transparent">
    <button
      type="button"
      className="flex w-full appearance-none flex-col gap-4 border-0 bg-transparent px-5 py-5 text-left shadow-none outline-none transition-colors hover:bg-primary/3 lg:flex-row lg:items-center lg:justify-between"
      onClick={onToggle}
    >
      <div className="flex min-w-0 flex-1 items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/12 text-primary">
          <Icon className="h-5 w-5" />
        </div>

        <div className="min-w-0 space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary">
              {title}
            </span>

            {linkHref ? (
              <a
                href={linkHref}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 text-[13px] font-medium text-foreground/78 transition-colors hover:text-primary dark:text-muted-foreground"
                onClick={(event) => event.stopPropagation()}
              >
                {linkLabel}
                <LinkIcon className="h-3.5 w-3.5" />
              </a>
            ) : null}

            {deletionCount > 0 ? (
              <span className="inline-flex rounded-full border border-rose-500/25 bg-rose-500/12 px-3 py-1 text-[11px] font-semibold text-rose-700 dark:text-rose-200">
                {deletionCount} deletions
              </span>
            ) : null}
          </div>

          <div className="flex flex-wrap gap-x-5 gap-y-2 text-[13px] text-foreground/72 dark:text-muted-foreground">
            {metaItems.map((item, index) => {
              const MetaIcon = item.icon;

              return (
                <span
                  key={`${String(item.label)}-${index}`}
                  className="inline-flex items-center gap-2"
                >
                  {MetaIcon ? <MetaIcon className="h-4 w-4" /> : null}
                  {item.label}
                </span>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 self-end lg:self-center">
        <div className="text-right">
          <div className="text-[22px] font-semibold text-foreground">{countValue}</div>
          <div className="text-[12px] text-foreground/72 dark:text-muted-foreground">{countLabel}</div>
        </div>

        <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-border/35 bg-transparent text-foreground/68 dark:text-muted-foreground">
          <ChevronRight
            className={cn(
              'h-4 w-4 transition-transform',
              isExpanded && 'rotate-90 text-primary'
            )}
          />
        </div>
      </div>
    </button>

    {isExpanded ? children : null}
  </section>
);

export default FileChangeGroupCard;
